import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { CSS_CLASS_PREFIX } from "../constants/css";
import {withTranslation} from "react-i18next";
import { Label, Label4G, Label5G } from "./Label";
import { formatDataCredits } from "../lib/formatData";

class DataCredits extends PureComponent {
  render() {
    return (
      <span>
        {this.formattedDataCredits()} {this.dataLabel()}
      </span>
    );
  }

  dataLabel() {
    const { gen } = this.props;

    if (gen === 5) {
      return (
        <Label5G small className={`${CSS_CLASS_PREFIX}-data-label`}>
          {gen}G
        </Label5G>
      );
    } else if (gen === 4) {
      return (
        <Label4G small className={`${CSS_CLASS_PREFIX}-data-label`}>
          {gen}G
        </Label4G>
      );
    } else if (gen != null) {
      return (
        <Label small className={`${CSS_CLASS_PREFIX}-data-label`}>
          {gen}G
        </Label>
      );
    } else {
      return null;
    }
  }

  formattedDataCredits() {
    const { amount, portal, showShort } = this.props;

    const formattedDataCredits = formatDataCredits(amount, {
      decimalSeparator: portal.decimalSeparator,
      showShort: showShort
    });
    return (
      <span>
        <span className={`${CSS_CLASS_PREFIX}-data-credits-amount`}>
          {formattedDataCredits.amount}
        </span>{" "}
        <span className={`${CSS_CLASS_PREFIX}-data-credits-unit`}>
          {formattedDataCredits.unit}
        </span>
      </span>
    );
  }
}

DataCredits.propTypes = {
  amount: PropTypes.number.isRequired,
  gen: PropTypes.number,
  portal: PropTypes.object.isRequired,
  showShort: PropTypes.bool
};

DataCredits.defaultProps = {
  showShort: false
};

export default withTranslation(["dataCredits"])(DataCredits);
